import React, { useState } from "react";
import * as Formik from "formik";
import { css } from "styled-components/macro";
import ImageSearchIcon from "@material-ui/icons/ImageSearch";
import { MediaUploader } from "../../modals/MediaUploader";
import Fab from "@material-ui/core/Fab";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { Image } from "../../components/Image";
import { ConfirmModal } from "../../modals/ConfirmModal";
import { FileInfo } from "../../components/FileInfo";

type Callback = () => void;

export function ImageField(props: {
  name: string;
  label: string;
  style?: "button";
  related?: boolean;
}) {
  const [showUploader, setShowUploader] = useState(false);
  const [confirmAction, setConfirmAction] = useState<null | Callback>(null);

  return (
    <Formik.Field
      name={props.name}
      render={({ form, field }: Formik.FieldProps) => {
        return (
          <React.Fragment>
            {props.style === "button" ? (
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  setShowUploader(true);
                }}
              >
                {field.value ? "Change image" : "Select image"}
              </Button>
            ) : (
              <div>
                <Typography variant="h5">{props.label}</Typography>
                <div
                  css={css`
                    margin-top: 10px;
                  `}
                >
                  {!field.value && (
                    <div
                      css={css`
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        height: 200px;
                        border-radius: 10px;
                        background: #f5f5f5;
                      `}
                      onClick={() => {
                        setShowUploader(true);
                      }}
                    >
                      <div
                        css={css`
                          width: 200px;
                          text-align: center;
                        `}
                      >
                        <ImageSearchIcon />
                        <p>Select Image</p>
                      </div>
                    </div>
                  )}
                  {field.value && (
                    <div
                      css={css`
                        position: relative;
                        display: inline-block;
                      `}
                    >
                      <Image
                        style={{
                          maxWidth: "300px",
                          maxHeight: "300px",
                        }}
                        file={props.related ? field.value.value : field.value}
                      />
                      <FileInfo
                        file={props.related ? field.value.value : field.value}
                      />
                      <div
                        css={css`
                          position: relative;
                          width: 100%;
                          display: flex;
                          flex-flow: row wrap;
                          justify-content: space-between;
                          padding: 10px 0;
                          border-top: 1px solid #ccc;
                          margin-top: 10px;
                        `}
                      >
                        <Fab
                          size="small"
                          color="secondary"
                          onClick={() => {
                            setConfirmAction(() => {
                              return () => {
                                form.setFieldValue(props.name, null);
                              };
                            });
                          }}
                        >
                          <DeleteIcon />
                        </Fab>
                        <Fab
                          size="small"
                          color="primary"
                          onClick={() => {
                            setShowUploader(true);
                          }}
                        >
                          <EditIcon />
                        </Fab>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {confirmAction !== null && (
              <ConfirmModal
                confirmAction={confirmAction}
                handleClose={() => {
                  setConfirmAction(null);
                }}
                open={true}
                label="Please confirm deletion"
              />
            )}
            {showUploader && (
              <MediaUploader
                open={true}
                handleClose={() => {
                  setShowUploader(false);
                }}
                onSelect={(file) => {
                  if (props.related) {
                    form.setFieldValue(props.name, {
                      type: "Related",
                      model: "Media",
                      value: file,
                    });
                  } else {
                    form.setFieldValue(props.name, file);
                  }
                }}
              />
            )}
          </React.Fragment>
        );
      }}
    />
  );
}
